import { Component, OnInit } from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DataService } from '../services/data.service';
import { ApiService } from '../services/api.service';
import { UserRoles } from '../constants/constants';
import { CommonModule } from '@angular/common';
import { InstallPromptService } from '../services/install-prompt.service';
import { environment } from '../../environment/environment';
@Component({
    selector: 'app-navigator',
    imports: [MatListModule, RouterModule, MatIconModule, MatButtonModule, CommonModule],
    templateUrl: './navigator.component.html',
    styleUrl: './navigator.component.scss'
})
export class NavigatorComponent implements OnInit {
  loggedInUserRole: string;
  isController: boolean = environment.isController;
  UserRoles= UserRoles
  constructor(private _bottomSheetRef: MatBottomSheetRef<NavigatorComponent>, private apiService: ApiService){}

  ngOnInit(){
     console.log('bottom sheet opened');
     this.apiService.getUserRoleIfTokenValid().subscribe(r=>
      this.loggedInUserRole=r);
  }
  clearCacheAndReload(): void {
    if ('caches' in window) {
      // Clear the cache
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    // Reload the page
    window.location.reload();
  }

  dismiss(){
    this._bottomSheetRef.dismiss();
  }

  logout(){
    console.info('logout buttong clicked');
    this.apiService.logout();
  }

}
